import { useGlobalContext } from "@/context/GlobalProvider";

export const useAllContent = () => {
  const { fetchAllContent, allContent } = useGlobalContext();

  return {
    fetchAllContent,
    allContent,
  };
};
